/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Digits {
  /**
   * The number of significant digits in a number
   *
   * @public
   * @function f1.digits
   * @param v a real number
   * @example
   *
   * ```ts
   * f1.digits(22.32) => 4
   * f1.digits(000) => 1
   * ```
   */
  (v: number): number;
}

/**
 * @see Digits
 */
export default (v: number): number => {
  return `${v}`.replace('.', '').length;
};
